/**
 * The one place the modal surface is described.
 *
 * Dialog, alert dialog, and the command palette are three files that each drew
 * their own popup: same intent, three copies of a ~40-class string, and they
 * had already drifted — the palette carried an extra `before:bg-muted/72` wash
 * the other two did not, which is what made it the brightest surface in the
 * app. Ported from t3code, which keeps these as shared constants for exactly
 * that reason.
 *
 * The color lives in the `dialog-glass` / `dialog-backdrop` utilities in
 * `index.css`; what is here is geometry and motion only. Anything that needs a
 * different width or max-height passes it at the call site.
 */

const DIALOG_BACKDROP_CLASS =
  "dialog-backdrop fixed inset-0 z-50 transition-all duration-200 data-ending-style:opacity-0 data-starting-style:opacity-0";

const DIALOG_POPUP_CLASS =
  "dialog-glass -translate-y-[calc(1.25rem*var(--nested-dialogs))] relative row-start-2 flex min-h-0 w-full min-w-0 scale-[calc(1-0.1*var(--nested-dialogs))] flex-col rounded-2xl border opacity-[calc(1-0.1*var(--nested-dialogs))] outline-none transition-[scale,opacity,translate] duration-200 ease-in-out will-change-transform data-nested:data-ending-style:translate-y-8 data-nested:data-starting-style:translate-y-8 data-nested-dialog-open:origin-top data-ending-style:scale-98 data-starting-style:scale-98 data-ending-style:opacity-0 data-starting-style:opacity-0";

export { DIALOG_BACKDROP_CLASS, DIALOG_POPUP_CLASS };
